import React, {
  lazy,
  Suspense,
  useEffect,
  useState,
} from "react";

import { HelmetProvider } from "react-helmet-async";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import "./App.css";

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppFloat from "./components/WhatsAppFloat/WhatsAppFloat";


const Home = lazy(() =>
  import("./components/Home/Home")
);

const About = lazy(() =>
  import("./components/About/About")
);
const Review = lazy(() =>
  import("./components/Review/Review")
);
const KaveriNews = lazy(() =>
  import("./components/Blog/KaveriNews")
);
const Project = lazy(() =>
  import("./components/Projects/Project")
);

const ProjectDetails = lazy(() =>
  import("./components/Projects/ProjectDetails")
);

const Blog = lazy(() =>
  import("./components/Blog/Blog")
);

const BlogPage = lazy(() =>
  import("./components/Blog/BlogPage")
);

const Careers = lazy(() =>
  import("./components/Career/Careers")
);

const Contact = lazy(() =>
  import("./components/Contact/Contact")
);


const PageLoader = ({ hidden }) => {
  return (
    <div
      className={`page-loader ${
        hidden ? "page-loader-hide" : ""
      }`}
      aria-hidden={hidden}
    >
      <div className="loader-content">

        <div className="loader-logo-wrapper">
          <img
            src="/kaveri-logo.webp"
            alt="Kaveri Group"
            className="loader-logo"
             width="180"
  height="80"
          />
        </div>

        <div className="loader-line">
          <span></span>
        </div>

      </div>
    </div>
  );
};


const waitForPageRender = () => {
  return new Promise((resolve) => {

    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        resolve();

      });

    });

  });
};

const LoaderController = () => {

  const location = useLocation();

  const [loading, setLoading] = useState(true);


  useEffect(() => {

    let active = true;
    setLoading(true);


    const loadPage = async () => {
      await waitForPageRender();

      await new Promise((resolve) => {
        setTimeout(resolve, 250);
      });


      if (!active) {
        return;
      }

      setLoading(false);

    };


    loadPage();

    const fallback = setTimeout(() => {

      if (active) {
        setLoading(false);
      }

    }, 5000);


    return () => {

      active = false;

      clearTimeout(fallback);

    };

  }, [location.pathname]);


  return (
    <PageLoader
      hidden={!loading}
    />
  );
};


const App = () => {

  return (
    <HelmetProvider>

      <Router>

        <LoaderController />

        <div className="website-content">

          <ScrollToTop />

          <Navbar />


          <Suspense fallback={null}>

            <Routes>

              <Route
                path="/"
                element={<Home />}
              />

              <Route
                path="/about-us"
                element={<About />}
              />

              <Route
                path="/project"
                element={<Project />}
              />

              <Route
                path="/projects/:slug"
                element={<ProjectDetails />}
              />

              <Route
                path="/resources"
                element={<Blog />}
              />
<Route path="/kaveri-news" element={<KaveriNews/>}/>
              <Route
                path="/blogpage/:slug"
                element={<BlogPage />}
              />

              <Route
                path="/careers"
                element={<Careers />}
              />

              <Route
                path="/review"
                element={<Review />}
              />

              <Route
                path="/contact-us"
                element={<Contact />}
              />

            </Routes>

          </Suspense>

          <Footer />

          <Suspense fallback={null}>
            <WhatsAppFloat />
          </Suspense>

        </div>

      </Router>

    </HelmetProvider>
  );
};


export default App;
